import React from 'react';
import styled from 'styled-components';
import {Button,Modal,Form,Space,Tooltip,Typography,Popover} from 'antd';
import {ExclamationCircleOutlined,InfoCircleOutlined } from '@ant-design/icons';
import TableEditRow from 'components/table/editable';
import TableEditDirect from 'components/table/editCell';
import SchemaForm from './schemaForm';
import Spreadsheet from './spreadsheet';
import Language from './language';
import { v4 as uuidv4 } from 'uuid';
import keywords,{keyToLabel} from './keywords';
import _ from 'lodash';
import {useParentState} from 'utils';
const Header=styled.div`
 display: flex;
 flex-direction: row;
 justify-content: space-between;

`;
const MyTooltip = styled(Tooltip)`
  color:red;
  
`
const {Title,Text,Paragraph}=Typography;

const MyPopover = ({info})=><Popover 
                placement="right" 
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={<div>{info}</div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover>

const getColumns = ({ schema,directEdit,parentData }) => {
  const columns = [];
  if(!schema) return [];
  
  const processProperty = (key, value,_schema) => {    
    if(value?.hide && !value?.showEdit)return;
    if(!directEdit &&value?.hide)return; 
    const {label,info,type,options,showFilters=true,group,shouldUpdate,defaultOptions=[],...other}=value;
    
    let column = {
      title: <Space><span>{label || key}</span>{info&& <MyPopover info={info}/>}</Space>,
      dataIndex: key,
      group,
      type,
      label,
      options,
      key: key,
      visible: key === "id" ? false : true,
      // visible: true,
      editable: true,
      render:(value,{errors})=><Space >{keyToLabel(group||key,value,"en")}{errors&&errors?.[key]&&<MyTooltip title={<Language id={errors?.[key]}/>}><ExclamationCircleOutlined /></MyTooltip>}</Space>,
      parentData,
      schema: _schema,
      ...other
    };

    if (type === "integer" || type === "number") {
      // column.sorter = (a, b) => a[key] - b[key];
    } else if (type === "boolean") {
      column.render = (text) => (text ? "Yes" : "No");
    } else if (options) {
      
      const _options = _.isFunction(options)?shouldUpdate?defaultOptions:options(parentData):options;      
      
      if(showFilters){
        column.filters = _options.map(({key:subkey,label}) => ({
          text: label,
          value: subkey,
        }));
        column.onFilter = (filterValue, record) => record[key] === filterValue;
      }
    }

    columns.push(column);
  };

  if (schema.type === "object") {
    // Handle object schema
    // console.log("process",schema)
    for (const [key, value] of Object.entries(schema.properties)) {
      // console.log("process",key,value)
      processProperty(key, value,schema);
    }
  } else if (schema.type === "array") {
    // Handle array schema
    const itemSchema = schema.items.properties;
    for (const [key, value] of Object.entries(itemSchema)) {
      processProperty(key, value,schema.items);
    }
   
  }

  return columns;
};



export default ({schema,parent,data:_data,setData:_setData,onEdit,showEdit=true,showAdd=true,directEdit=false})=>{
  const [data, setData] = useParentState(_data,_setData);
  
  const [showSpreadsheet,setShowSpreadsheet]=React.useState(false);
  const [showModal,setShowModal]=React.useState(false);
  
  const handleCancel = ()=>{    
    setShowModal(false);
  };
  const handleOk = (newItem)=>{   
    // console.log("newItem",newItem)
    setData([...data||[],newItem]);
    handleCancel();
  };
  
  
  const MyTable = directEdit?TableEditDirect:TableEditRow;
  const columns=getColumns({schema,directEdit,parentData:parent});
  
  const {modalWidth=600}=schema;
  
  
  
  return (
    <div style={{overflow: "auto"}}>
    <Header>
    <Title level={5} style={{margin:0}}>{schema?.labelExtra}</Title>
    <Space>
      {/*showEdit && <Button type="primary" onClick={()=>setShowSpreadsheet(true)}><Language id="import"/></Button>                  */}
      {showAdd  && <Button type="primary" onClick={()=>setShowModal(true)}><Language id="add"/></Button>            }
      </Space>
       </Header>
      <MyTable 
        rowKey={"id"} 
        columns={columns} 
        data={data} 
        setData={(a)=>setData(a)}
        showHeader={false}
        rowSelection={false}
        onEdit={onEdit}   
        
        schema={schema.items} 
        parentData={parent}
  
      
      />
      {showEdit && <Spreadsheet {...{schema,data,isVisible:showSpreadsheet,setVisible:setShowSpreadsheet,onFinish:setData,columns}} />}
      <Modal
        title=<Language id="new"/>
        onCancel={handleCancel}
        closable={false}
  	    open={showModal}
  	    footer={null}
  	    width={modalWidth}
  	    destroyOnClose={true}
  	   // onOk={handleOk}  	    
      >
        <SchemaForm schema={schema.items} parentData={parent} data={{id:uuidv4(),retrofitType:"None"}} setData={handleOk} showSubmit={true}/>
      </Modal>
      
      
    </div>
  )
}